import { CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import BasicPagination from "../../../pagination/BasicPagination";
import { useIsAccessAllow } from "../../../users/redux";
import Checkbox from "../../../../components/Checkbox";
import "../../../cold_leads/pages/cold_leads_detail/modernTable.scss";
import "./blogTable.scss";
import {
  FdcBlogActions,
  deleteBlogAsync,
  getAllBlogAsync,
  updateSelectedBlogStatusAsync,
} from "../../redux";
import { FdcBlogStatus } from "../../constants/constants";

const bulkStatusOptionList = [
  { status: "Draft", value: FdcBlogStatus.DRAFT },
  { status: "Published", value: FdcBlogStatus.PUBLISHED },
  // { status: "Pending Review", value: FdcBlogStatus.PENDING_REVIEW },
  { status: "Future", value: FdcBlogStatus.FUTURE },
  // { status: "Auto Draft", value: FdcBlogStatus.AUTO_DRAFT },
];

const FdcBlogTable = () => {
  const history = useHistory();
  const {
    isLoading,
    blogList,
    skip,
    limit,
    searchBy,
    searchText,
    status,
  } = useSelector((state) => state.blog, shallowEqual);

  useEffect(() => {
    dispatch(getAllBlogAsync(searchBy, searchText, status));
    // eslint-disable-next-line
  }, []);

  const dispatch = useDispatch();
  const onPageChange = (currentBatch) => {
    let count = currentBatch ? currentBatch - 1 : skip;
    dispatch(FdcBlogActions.setBlogBatchNumber(count));
  };

  const onEditClick = (data) => {
    history.push(`/fdc_blog/edit-blog/${data?._id}`);
  };
  const onDeleteClick = (data) => {
    if (window.confirm("Are you sure you want to delete?")) {
      dispatch(deleteBlogAsync(data?._id));
      dispatch(getAllBlogAsync(searchBy, searchText, status));
    }
  };
  const statusOptionList = {
    draft: "draft",
    published: "Published",
    pending_review: "Pending Review",
    future: "Future",
    auto_draft: "Auto Draft",
  };
  const getStatuslabel = (status) => {
    if (status && statusOptionList[status]) {
      return statusOptionList[status];
    }
    return status;
  };
  const frontend_website_url = process.env.REACT_APP_FDC_WEBSITE_URL || "";

  const isDeleteAllow = useIsAccessAllow("fdc_blog.delete_blog");
  const isEditBlogAllow = useIsAccessAllow("fdc_blog.edit_blog");
  const isViewLogAllow = useIsAccessAllow("fdc_blog.view_log");

  // Bulk status update: select rows, click "Update Status" to reveal a
  // status dropdown + confirm button, applies to all selected blogs at once.
  const [checkIds, setCheckIds] = useState([]);
  const [showBulkStatus, setShowBulkStatus] = useState(false);
  const [bulkStatus, setBulkStatus] = useState("");
  const [isBulkUpdating, setIsBulkUpdating] = useState(false);

  // If the selection drops to zero (unchecking rows one by one, or
  // toggling "select all" off) while the status dropdown is open, close it
  // too — it shouldn't stay visible once there's nothing left to update.
  useEffect(() => {
    if (checkIds.length === 0 && showBulkStatus) {
      setShowBulkStatus(false);
      setBulkStatus("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkIds]);

  // Selection is scoped to the current page - clear it whenever the page
  // changes so a selection made on page 1 does not silently linger (and
  // get counted/acted on) once the user has paginated to a different set
  // of records that were never actually checked.
  useEffect(() => {
    setCheckIds([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skip]);

  // Header "select all" checkbox state is derived from the actual
  // selection (rather than tracked separately) so it stays in sync when
  // individual rows are checked/unchecked one at a time - otherwise it
  // could keep showing "checked" after a row was manually unchecked.
  const isAllChecked =
    !!blogList.records?.length &&
    blogList.records.every((li) => checkIds.includes(li._id));

  const allChecked = () => {
    setCheckIds(
      isAllChecked
        ? []
        : blogList.records
        ? blogList.records.map((li) => li._id)
        : []
    );
  };

  const oneChecked = (e) => {
    const { id, checked } = e.target;
    setCheckIds((prev) =>
      checked ? [...prev, id] : prev.filter((item) => item !== id)
    );
  };

  const handleUpdateStatusClick = () => {
    setShowBulkStatus((prev) => !prev);
  };

  const handleBulkStatusConfirm = async () => {
    if (!checkIds.length || !bulkStatus) return;
    setIsBulkUpdating(true);
    try {
      const success = await dispatch(
        updateSelectedBlogStatusAsync(checkIds, bulkStatus),
      );
      if (success) {
        dispatch(getAllBlogAsync(searchBy, searchText, status));
        setCheckIds([]);
        setShowBulkStatus(false);
        setBulkStatus("");
      }
    } finally {
      setIsBulkUpdating(false);
    }
  };

  return (
    <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position">
      <div className="tblmrgn mt-0">
        <div className="mt-5">
          {isEditBlogAllow && (
            <div className="mt-4 mb-4 d-flex align-items-center flex-wrap" style={{ gap: "10px" }}>
              <button
                type="button"
                className="custom-action-button button-primary"
                style={{ margin: 0 }}
                disabled={checkIds.length === 0}
                onClick={handleUpdateStatusClick}
              >
                Update Status{checkIds.length > 0 ? ` (${checkIds.length})` : ""}
              </button>
              {showBulkStatus && (
                <>
                  <select
                    className="form-control form-control-sm"
                    style={{ width: "auto", minWidth: "160px", height: "42px", margin: 0}}
                    value={bulkStatus}
                    onChange={(e) => setBulkStatus(e.target.value)}
                  >
                    <option value="">Select status</option>
                    {bulkStatusOptionList.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.status}
                      </option>
                    ))}
                  </select>
                  <button
                    type="button"
                    className="custom-action-button button-success"
                    style={{ margin: 0 }}
                    disabled={!bulkStatus || isBulkUpdating}
                    onClick={handleBulkStatusConfirm}
                  >
                    {isBulkUpdating ? "Updating..." : "Update"}
                  </button>
                </>
              )}
            </div>
          )}
          <div>
            <Table
              hover
              responsive
              className="mb-0 default_table with_hoverbtn mrpdng_tbl"
            >
              <thead>
                <tr>
                  {isEditBlogAllow && (
                    <th style={{ width: "40px" }}>
                      <label className="custom-checkbox-wrapper">
                        <Checkbox
                          type="checkbox"
                          name="checkAll"
                          id="checkAll"
                          handleClick={allChecked}
                          isChecked={isAllChecked}
                        />
                        <span className="custom-checkbox"></span>
                      </label>
                    </th>
                  )}
                  <th>Sr No.</th>
                  <th>Slug</th>
                  <th>Title</th>
                  <th>Tags</th>
                  <th>Categories</th>
                  <th>Created On</th>
                  <th>Status</th>
                  <th width="140">Action</th>
                </tr>
              </thead>
              <tbody>
                {blogList.records && blogList.records.length ? (
                  blogList.records.map((blogLists, index) => (
                    <tr key={blogLists._id || index}>
                      {isEditBlogAllow && (
                        <td>
                          <label className="custom-checkbox-wrapper">
                            <Checkbox
                              type="checkbox"
                              name={blogLists._id}
                              id={blogLists._id}
                              handleClick={oneChecked}
                              isChecked={checkIds.includes(blogLists._id)}
                            />
                            <span className="custom-checkbox"></span>
                          </label>
                        </td>
                      )}
                      <td>
                        <span>{skip * limit + (index + 1)}</span>
                      </td>
                      <td>
                        <span>{blogLists.slug}</span>
                      </td>
                      <td>
                        <span>{blogLists.title}</span>
                      </td>
                      <td>
                        <span>
                          {blogLists.tags ? blogLists.tags.join(", ") : ""}
                        </span>
                      </td>
                      <td>
                        <span>
                          {blogLists.categories
                            ? blogLists.categories.join(", ")
                            : ""}
                        </span>
                      </td>
                      <td>
                        <span>
                          {new Date(blogLists.createdOn).toLocaleString()}
                        </span>
                      </td>
                      <td>
                        <span style={{ textTransform: "capitalize" }}>
                          {getStatuslabel(blogLists.status)}
                        </span>
                      </td>
                      <td>
                        <a
                          href={`${frontend_website_url}/${blogLists.slug}`}
                          rel="noreferrer"
                          target="_blank"
                          title="Preview"
                          className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3 mb-2"
                        >
                          <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/custom/eye.svg"
                              )}
                            />
                          </span>
                        </a>

                        {isViewLogAllow && (
                          <a
                            href={`/fdc_blog_log/${blogLists._id}`}
                            target="_blank"
                            rel="noreferrer"
                            title="View Log"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3 mb-2"
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                title="View Log"
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/custom/history.svg"
                                )}
                              />
                            </span>
                          </a>
                        )}

                        {isEditBlogAllow && (
                          <button
                            title="Edit"
                            className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3 mb-2"
                            onClick={() => onEditClick(blogLists)}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-primary">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/Communication/Write.svg"
                                )}
                              />
                            </span>
                          </button>
                        )}

                        {isDeleteAllow && (
                          <button
                            title="Delete"
                            className="btn btn-icon btn-light btn-hover-danger btn-sm mb-2"
                            onClick={() => onDeleteClick(blogLists)}
                          >
                            <span className="svg-icon svg-icon-md svg-icon-danger">
                              <SVG
                                src={toAbsoluteUrl(
                                  "/media/svg/icons/General/Trash.svg"
                                )}
                              />
                            </span>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={isEditBlogAllow ? 9 : 8} className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          {!isLoading && (
            <div className="row d-flex align-items-center mr-5 ml-5 mt-4">
              <div className="col-md-8 text-right mb-5 aspgntn">
                <BasicPagination
                  totalRecords={blogList.recordsTotal}
                  limit={limit}
                  batch={skip + 1}
                  onBatchChange={onPageChange}
                />
              </div>
              <div className="col-md-4 mb-5 fn_s_16 f-w-400 text-right">
                Displaying {skip * limit + 1} - {skip * limit + limit} of{" "}
                {blogList.recordsTotal} Records
              </div>
            </div>
          )}
          {isLoading && (
            <div style={{ flex: "0 0 auto" }}>
              <div style={{ justifyContent: "center" }} className="text-center">
                <div className="basic-verification-loader text-center">
                  <CircularProgress />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FdcBlogTable;
